
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from "@/components/ui/separator";

const Cookies = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="container mx-auto px-4 pt-32 pb-16 max-w-4xl">
        <h1 className="text-3xl font-bold text-darkgray mb-6 font-montserrat">Cookie-policy</h1>
        
        <div className="prose prose-yellow max-w-none space-y-6 text-darkgray/80 font-opensans">
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">1. Vad är cookies?</h2>
            <p>Cookies är små textfiler som lagras på din dator eller mobila enhet när du besöker en webbplats. De används för att få webbplatsen att fungera effektivt, samla in information om ditt besök och dina preferenser, och för att förbättra din användarupplevelse.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">2. Hur vi använder cookies</h2>
            <p>Snabbaupphandlingar använder cookies för att:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Säkerställa att webbplatsen fungerar korrekt för upphandlingsanalyser</li>
              <li>Spara dina inställningar och preferenser för anbudsarbete</li>
              <li>Ge dig en personlig upplevelse av vår upphandlingstjänst</li>
              <li>Samla in anonymiserad statistik om hur webbplatsen används</li>
              <li>Förbättra vår upphandlingsplattform och dess funktioner</li>
              <li>Möjliggöra säkra och effektiva inloggningsfunktioner för ditt konto</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">3. Typer av cookies vi använder</h2>
            <p><strong>Nödvändiga cookies:</strong> Dessa cookies är väsentliga för att du ska kunna använda grundläggande funktioner på vår upphandlingsplattform, såsom inloggning och formulärhantering.</p>
            <p><strong>Preferenscookies:</strong> Dessa cookies gör det möjligt för webbplatsen att komma ihåg information som förändrar webbplatsens beteende eller utseende, som dina preferenser för upphandlingsbevakning.</p>
            <p><strong>Statistikcookies:</strong> Dessa cookies hjälper oss att förstå hur besökare interagerar med upphandlingsfunktionerna genom att samla in och rapportera information anonymt.</p>
            <p><strong>Marknadsföringscookies:</strong> Dessa cookies används för att spåra besökare på olika webbplatser. Avsikten är att visa annonser som är relevanta och engagerande för användare intresserade av upphandlingstjänster.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">4. Tredjepartscookies</h2>
            <p>Vi använder även cookies från betrodda tredje parter för att hjälpa oss analysera hur vår upphandlingsplattform används och för att förbättra användarupplevelsen. Dessa tredje parter kan inkludera:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Google Analytics (för webbplatsanalys av användning av upphandlingstjänster)</li>
              <li>Sociala medieplattformar som LinkedIn (för delningsfunktioner och marknadsföring av upphandlingstips)</li>
              <li>Betalningsprocessorer för säkra transaktioner av våra tjänster</li>
            </ul>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">5. Hur du hanterar cookies</h2>
            <p>De flesta webbläsare är inställda att acceptera cookies som standard. Du kan dock ändra dina inställningar för:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Blockera alla cookies</li>
              <li>Tillåta endast första parts cookies</li>
              <li>Radera cookies när du stänger webbläsaren</li>
              <li>Acceptera eller blockera specifika cookies</li>
            </ul>
            <p>Instruktioner för hur du hanterar cookies i din webbläsare finns vanligtvis i webbläsarens hjälpsektion.</p>
            <p>Observera att om du väljer att blockera cookies kan det påverka funktionaliteten på vår upphandlingsplattform, särskilt funktioner för inloggning och sparade upphandlingar.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">6. Cookie-samtyckeshantering</h2>
            <p>När du först besöker vår webbplats kommer du att få ett meddelande om cookies där du kan ge ditt samtycke till användningen av cookies. Du kan när som helst ändra dina preferenser genom att klicka på "Cookie-inställningar" längst ned på varje sida på vår upphandlingsplattform.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">7. Ändringar i vår cookie-policy</h2>
            <p>Vi kan komma att uppdatera vår cookie-policy från tid till annan för att återspegla förändringar i vår användning av cookies eller för att förbättra vår upphandlingsplattform. När vi gör det kommer vi att publicera den uppdaterade policyn på denna sida och uppdatera datumet för "Senast uppdaterad" nedan.</p>
            <p>Vi uppmuntrar dig att regelbundet granska denna policy för att hålla dig informerad om hur vi använder cookies på vår upphandlingsplattform.</p>
          </section>
          
          <Separator className="bg-yellow-500" />
          
          <section>
            <h2 className="text-xl font-semibold text-darkgray mb-3 font-montserrat">8. Kontakta oss</h2>
            <p>Om du har några frågor om vår användning av cookies på upphandlingsplattformen, vänligen kontakta oss på:</p>
            <p className="mt-2">
              E-post: kontakt@snabbaupphandlingar.se<br />
              Adress: Skallebackavägen 13, 32 41 Halmstad
            </p>
          </section>
          
          <p className="mt-8 text-sm">Senast uppdaterad: 1 juni 2024</p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Cookies;
